export default "__VITE_ASSET__C0PHRs36__"